import React, { Suspense, useState, useEffect, useMemo } from 'react'
import { Button, Card, CardContent, CardHeader, Container, Grid, Typography } from '@mui/material';
import { useGetAccountsQuery } from '../../../api/recalc/endpoints/accountsApiSlice';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { useNavigate, useLocation, Navigate, Link } from 'react-router-dom';
import AccountDrawerContainer from './AccountDrawerContainer';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../redux/snackbarSlice';
import { getSelectedAccount } from '../../../redux/selectedAccountSlice';


//   Import some federated module here


const ServiceManagementDatagrid = React.lazy(() =>
  import('remote/ServiceManagementDatagrid').catch(() => ({
    default: () => <div>Failed to load</div>,
  }))
);
const ServiceManagementPage = () => {

  const [selectedRow, setSelectedRow] = useState({});
  const selectedAccount = useSelector(getSelectedAccount);

  useEffect(() => {
    // Do something with the state here
  }, []);


  // Use navigate here for navigation
  // Usage: navigate('/path/to/navigate', { state: { key: value } });
  const navigate = useNavigate();
  const dispatch = useDispatch();


  const { data: accounts, isLoading, isSuccess: isSuccessAccounts, isError: isErrorAccounts, error: errorAccounts, isFetching } = useGetAccountsQuery()


  useEffect(() => {
    if (!selectedRow?.Name) return;

    setSelectedRow(accounts?.find(account => account.Name === selectedRow?.Name))

  }, [accounts])

  return (
    <Container maxWidth='xxl'>
      <Suspense fallback={
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', verticalAlign: 'center' }}>
          <CircularProgress />
        </Box>
      }>
        <Box sx={{ display: 'flex', height: '70vh', width: '100%' }}>
          <Grid container spacing={2}>

            {[
              { label: 'Basis', name: 'Basis', path: '/service-management/Basis' },
              { label: 'PVO', name: 'PVO', path: '/operations' },
              { label: 'EnergyXplorer', name: 'EnergyXplorer', path: '/service-management/energyxplorer' },
              { label: 'Portfolio Analysis', name: 'PortfolioAnalysis', path: '/service-management/portfolio-analysis' }].map(service => <Grid item lg={3}>
                <ServiceCard {...service} accounts={accounts} />
              </Grid>)}
            <Grid item lg={12}  height={'80vh'}>
              <ServiceManagementDatagrid initialRows={accounts?.map(account => {
                return {
                  ...account,
                  id: account.AccountId,
                }
              })} isLoading={isFetching} setSelectedRow={setSelectedRow} account={selectedAccount} />
            </Grid>
          </Grid>
        </Box>
      </Suspense>
      <AccountDrawerContainer isOpen={selectedRow?.Name} onClose={() => setSelectedRow({})} account={selectedRow} />
    </Container>
  )
}

export default ServiceManagementPage


const ServiceCard = (props) => {
  const { name, label = name, accounts = [], path } = props
  const serviceCount = useMemo(() => {
    return accounts.reduce((acc, account) => {
      if (account.Services.some(s => s.Name === name)) return acc + 1;
      return acc;
    }, 0)
  }, [name, accounts])
  return (
    <Card variant='outlined'>
      <Link to={`${path}`}>


        <CardContent>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', mb: 2 }}>
            <Typography variant="body1" color="textSecondary" fontWeight="bold">
              {label}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <Typography variant="h4" color="textPrimary" fontWeight={'bold'}>
                {serviceCount}
              </Typography>
            </Box>
          </Box>
        </CardContent>
      </Link>
    </Card>
  )

}